import {
    createRouter,
    createWebHistory,
    RouteRecordRaw
} from 'vue-router'
import * as NProgress from 'nprogress'
import SidebarLayout from '../layouts/SidebarLayout.vue'

const routes: Array<RouteRecordRaw> = [
    {
        component: () => import('/src/pages/index.vue'),
        name: 'Index',
        path: '/',
        props: true,

        meta: {
            auth: true,
            layout: SidebarLayout,
        },
    },
    {
        component: () => import('/src/pages/auth/Login.vue'),
        name: 'login',
        path: '/login',
        props: true
    },
    {
        component: () => import('/src/pages/auth/Forgot.vue'),
        name: 'forgot',
        path: '/forgot',
        props: true
    },
    {
        component: () => import('/src/pages/auth/Reset.vue'),
        name: 'reset',
        path: '/reset',
        props: true
    },
    {
        component: () => import('/src/pages/stream/StreamY.vue'),
        name: 'yield',
        path: '/yield',
        props: true,
        meta: {auth: true},
    },
    {
        component: () => import('/src/pages/stream/StreamDrift.vue'),
        name: 'drift',
        path: '/drift',
        props: true,
        meta: {auth: true},
    },
    {
        component: () => import('/src/pages/stream/StreamF.vue'),
        name: 'stream-futures',
        path: '/streamfutures',
        props: true,
        meta: {auth: true},
    },
    {
        component: () => import('/src/pages/stream/StreamA.vue'),
        name: 'stream-alerts',
        path: '/alertstratsalertstrats',
        props: true,
        meta: {auth: true},
    },
    {
        component: () => import('/src/pages/stream/StreamC.vue'),
        name: 'stream-custom',
        path: '/streamcustom',
        props: true,
        meta: {auth: true},
    },
    {
        component: () => import('/src/pages/yieldcheck.vue'),
        name: 'yield-check',
        path: '/yieldcheck',
        props: true,
        meta: {auth: true},
    },
    {
        component: () => import('/src/pages/yieldchecknew.vue'),
        name: 'yield-check-new',
        path: '/yieldchecknew',
        props: true,
        meta: {auth: true},
    },
    {
        component: () => import('/src/pages/custompagebuilder.vue'),
        name: 'custom-page-builder',
        path: '/custompagebuilder',
        props: true,
        meta: {auth: true},
    },
    {
        component: () => import('/src/pages/grouppagebuilderusers.vue'),
        name: 'group-page-builder-users',
        path: '/grouppagebuilderusers',
        props: true,
        meta: {auth: true},
    },
    {
        component: () => import('/src/pages/grouppagebuilderstrats.vue'),
        name: 'group-page-builder-strats',
        path: '/grouppagebuilderstrats',
        props: true,
        meta: {auth: true},
    },
    {
        component: () => import('/src/pages/orders/Orders.vue'),
        name: 'orders-list',
        path: '/orderslist',
        props: true,
        meta: {auth: true},
    },
    {
        component: () => import('/src/pages/orders/MyOrders.vue'),
        name: 'customer-orders-list',
        path: '/my-orders',
        props: true,
        meta: {auth: true},
    },
    {
        component: () => import('/src/pages/orders/EndofdayRepo.vue'),
        name: 'endofdayrepo',
        path: '/endofdayrepo',
        props: true,
        meta: {auth: true},
    },
    {
        component: () => import('/src/pages/repohistory.vue'),
        name: 'repo-history',
        path: '/repohistory',
        props: true,
        meta: {auth: true},
    },
    {
        component: () => import('/src/pages/cix.vue'),
        name: 'cix-parser',
        path: '/cix',
        props: true,
        meta: {auth: true},
    },
    // {
    //     component : () => import('/src/pages/notifications/NotificationsDashboard.vue') ,
    //     name : 'notifications-dashboard' ,
    //     path : '/notificationsdashboard' ,
    //     props : true ,
    //     meta : { auth : true },
    // },
    {
        path: "/stratslist",
        name: "strats-list",
        meta: {auth: true},

        component: () => import('/src/pages/stratlist.vue'),
        children: [
            {
                path: 'mid-prices/',
                name: 'StrategiesMidPrices',
                // route level code-splitting
                // this generates a separate chunk (strategies.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                meta: {auth: true},
                component: () => import('/src/pages/indices/MidPrices.vue')
            },
            {
                path: ':id/',
                name: 'StrategiesRead',
                meta: {auth: true},
                component: () => import(/* webpackChunkName: "strategies_index" */ '/src/pages/indices/IndexHome.vue')
            },
            {
                path: 'create/',
                name: 'StrategiesCreate',
                props: true,
                meta: {auth: true},
                component: () => import(/* webpackChunkName: "strategies_create" */ '/src/pages/indices/IndexCreate.vue')
            },
            {
                path: ':id/edit/',
                name: 'StrategiesUpdate',
                // route level code-splitting
                // this generates a separate chunk (strategies.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                meta: {auth: true},
                component: () => import(/* webpackChunkName: "strategies_update" */ '/src/pages/indices/IndexUpdate.vue')
            },
            {
                path: ':id/copy/',
                name: 'StrategiesCopy',
                // route level code-splitting
                // this generates a separate chunk (strategies.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                meta: {auth: true},
                component: () => import(/* webpackChunkName: "strategies_update" */ '/src/pages/indices/IndexCopy.vue')
            },
            {
                path: ':id/delete/',
                name: 'StrategyDelete',
                // route level code-splitting
                // this generates a separate chunk (strategies.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                meta: {auth: true},
                component: () => import(/* webpackChunkName: "strategies_update" */ '/src/pages/indices/IndexDelete.vue')
            },

        ]
    },
]

const router = createRouter({
    /**
     * If you need to serve vuero under a subdirectory,
     * you have to set the name of the directory in createWebHistory here
     * and update "base" config in vite.config.ts
     */
    history: createWebHistory(),
    routes,
});


router.afterEach(() => {

    NProgress.done()
})

export default router;

